<div class="input creditcard-indicator">
  <label class="required" i18n="@@payment_method.label.creditcard_number">
    Kreditkarten-Nummer
  </label>
  <div
    id="cc_number-{{ uniqueInstanceId }}"
    class="form-control ng-touched ng-dirty"
    [ngClass]="creditCardType$ | async"
    [class.ng-invalid]="unzerErrorByField$.number | async"
    [class.ng-valid]="paymentFieldSuccessState$.number | async"
  ></div>
  <div
    class="error-container"
    *ngIf="unzerErrorByField$.number | async as error"
  >
    {{ error }}
  </div>
</div>

<div class="d-flex">
  <div class="input">
    <label class="required" i18n="@@payment_method.label.valid_to">
      Gültig bis
    </label>
    <div
      id="cc_expiry-{{ uniqueInstanceId }}"
      class="form-control ng-touched ng-dirty"
      [class.ng-invalid]="unzerErrorByField$.expiry | async"
      [class.ng-valid]="paymentFieldSuccessState$.expiry | async"
    >
    </div>
    <div
      class="error-container"
      *ngIf="unzerErrorByField$.expiry | async as error"
    >
      {{ error }}
    </div>
  </div>

  <div class="input" id="creditcard_securitycode">
    <div class="label-container">
      <label i18n="@@payment_method.label.cvv" class="required">CVV </label>
      <a
        id="creditcard_securitycode_help"
        href="#"
        tabindex="-1"
        i18n="
          Es geht um die
          Kreditkartenprüfnummer@@lpayment_method.label.cvv_whats_this"
        (click)="$event.preventDefault(); cvcDialog.open()"
        >Was ist CVV?</a
      >
    </div>
    <div
      id="cc_cvc-{{ uniqueInstanceId }}"
      class="form-control ng-touched ng-dirty"
      [class.ng-invalid]="unzerErrorByField$.cvc | async"
      [class.ng-valid]="paymentFieldSuccessState$.cvc | async"
    >
    </div>
    <div
      class="error-container"
      *ngIf="unzerErrorByField$.cvc | async as error"
    >
      {{ error }}
    </div>
  </div>
</div>

<orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
